<template>
  <div class="contain contactus">
    <Banner
      ref="cBanner"
      :banner_img="resBanners"
      banner_en="CONTACT US"
      banner_cn="联系我们"
    ></Banner>
    <Contactus></Contactus>
  </div>
</template>
<script>
import Contactus from "@/components/contactus/Contactus";
import Banner from "@/components/common/Banner.vue";

export default {
  data() {
    return {
      resBanners: [
        // {
        //   imageUrl: require("../assets/images/contactus/banner.jpg"),
        //   skipHref: "",
        // },
      ],
    };
  },
  mounted() {
    new this.$wow.WOW({
      live: false,
      offset: 0,
    }).init();
    this.getDataList();
  },
  methods: {
    async getDataList() {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: "5",
      });
      if (res.code === 200) {
        this.resBanners = [];
        res.rows.map((item, index) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl;
        });
        this.resBanners = res.rows;
        this.$nextTick(() => {
          this.$refs.cBanner.reInitBanner();
        });
      }
    },
  },
  components: {
    Contactus,
    Banner,
  },
};
</script>
<style lang="scss" scoped>
</style>
